import { RootState } from '@/store'
import { getUsers } from '@/store/selectors'
import { mapToUser } from '@/utilities/UserUtilities'

export const getPageOfGroupMembers = (state: RootState) => {
  const pageOfMembers = state.organizationGroupsMembersPage.page
  if (pageOfMembers) {
    const users = getUsers(state)
    return pageOfMembers.map(pageUser => {
      return {
        ...mapToUser(users.byId[pageUser])
      }
    })
  }
}
export const getGroup = (state: RootState) => {
  return state.organizationGroupsMembersPage.group || {}
}
export const getTotalUsers = (state: RootState) => {
  return state.organizationGroupsMembersPage.totalUsers || 0
}
export const getStartIndex = (state: RootState) => {
  return state.organizationGroupsMembersPage.startIndex || 1
}
export const getFilter = (state: RootState) => {
  return state.organizationGroupsMembersPage.filter || ''
}
export const getSortingColumn = (state: RootState) => {
  return state.organizationGroupsMembersPage.sortingColumn
}
